import { ShieldCheck } from "lucide-react";

export default function VerifiedBadge({ small = false, notes }) {
  return (
    <div
      data-testid="verified-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border border-gold/40 bg-gold/10 ${
        small ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs"
      } font-medium text-forest`}
      title={notes || "Verified by Our First Realty"}
    >
      <ShieldCheck className={small ? "w-3.5 h-3.5 text-gold" : "w-4 h-4 text-gold"} />
      <span>Verified by Our First Realty</span>
    </div>
  );
}
